module.exports = __webpack_public_path__ + "static/media/icon-exclamation-mark.c57d4cc0.png";